module.exports = __webpack_public_path__ + "static/stay complaint-be30355602801811f00161fa9f50751b.jpg";